import { Socket } from 'rete'

import CONST_SOCKET from '../const/socket'

export default {
  referenceInput: new Socket(CONST_SOCKET.REFERENCE_INPUT),
  referenceInputActionButton: new Socket(CONST_SOCKET.REFERENCE_INPUT_ACTION_BUTTON),

  referenceOutput: new Socket(CONST_SOCKET.REFERENCE_OUTPUT),
  referenceOutputSequence: new Socket(CONST_SOCKET.REFERENCE_OUTPUT_SEQUENCE),
  
  newPostbackInputTrigger: new Socket(CONST_SOCKET.NEW_POSTBACK_INPUT_TRIGGER),
  newPostbackInput: new Socket(CONST_SOCKET.NEW_POSTBACK_INPUT),
  newPostbackOutput: new Socket(CONST_SOCKET.NEW_POSTBACK_OUTPUT),
  newPostbackOutputSequence: new Socket(CONST_SOCKET.NEW_POSTBACK_OUTPUT_SEQUENCE),
  
  triggerInput: new Socket(CONST_SOCKET.TRIGGER_INPUT),
  triggerOutput: new Socket(CONST_SOCKET.TRIGGER_OUTPUT),
  
  textInput: new Socket(CONST_SOCKET.TEXT_INPUT),
  textOutput: new Socket(CONST_SOCKET.TEXT_OUTPUT),
  textOutputButton: new Socket(CONST_SOCKET.TEXT_OUTPUT_BUTTON),
  textOutputQuickreply: new Socket(CONST_SOCKET.TEXT_OUTPUT_QUICKREPLY),
  
  carouselInput: new Socket(CONST_SOCKET.CAROUSEL_INPUT),
  carouselOutput: new Socket(CONST_SOCKET.CAROUSEL_OUTPUT),
  carouselOutputItems: new Socket(CONST_SOCKET.CAROUSEL_OUTPUT_ITEMS),
  carouselOutputQuickreply: new Socket(CONST_SOCKET.CAROUSEL_OUTPUT_QUICKREPLY),
  
  carouselSingleInput: new Socket(CONST_SOCKET.CAROUSEL_SINGLE_INPUT),
  carouselSingleOutputButton: new Socket(CONST_SOCKET.CAROUSEL_SINGLE_OUTPUT_BUTTON),
  
  componentListInput: new Socket(CONST_SOCKET.COMPONENT_LIST_INPUT),

  facebookMediaInput: new Socket(CONST_SOCKET.FACEBOOK_MEDIA_INPUT),
  facebookMediaOutput: new Socket(CONST_SOCKET.FACEBOOK_MEDIA_OUTPUT),
  facebookMediaOutputButton: new Socket(CONST_SOCKET.FACEBOOK_MEDIA_OUTPUT_BUTTON),
  facebookMediaOutputQuickreply: new Socket(CONST_SOCKET.FACEBOOK_MEDIA_OUTPUT_QUICKREPLY),
  
  imageInput: new Socket(CONST_SOCKET.IMAGE_INPUT),
  imageOutput: new Socket(CONST_SOCKET.IMAGE_OUTPUT),
  imageOutputQuickreply: new Socket(CONST_SOCKET.IMAGE_OUTPUT_QUICKREPLY),
  
  videoInput: new Socket(CONST_SOCKET.VIDEO_INPUT),
  videoOutput: new Socket(CONST_SOCKET.VIDEO_OUTPUT),
  videoOutputQuickreply: new Socket(CONST_SOCKET.VIDEO_OUTPUT_QUICKREPLY),
  
  audioInput: new Socket(CONST_SOCKET.AUDIO_INPUT),
  audioOutput: new Socket(CONST_SOCKET.AUDIO_OUTPUT),
  audioOutputQuickreply: new Socket(CONST_SOCKET.AUDIO_OUTPUT_QUICKREPLY),
  
  fileInput: new Socket(CONST_SOCKET.FILE_INPUT),
  fileOutput: new Socket(CONST_SOCKET.FILE_OUTPUT),
  fileOutputQuickreply: new Socket(CONST_SOCKET.FILE_OUTPUT_QUICKREPLY),
  
  quickReplyInput: new Socket(CONST_SOCKET.QUICK_REPLY_INPUT),
  quickReplyOutput: new Socket(CONST_SOCKET.QUICK_REPLY_OUTPUT),
  quickReplyOutputSequence: new Socket(CONST_SOCKET.QUICK_REPLY_OUTPUT_SEQUENCE),
  
  buttonInput: new Socket(CONST_SOCKET.BUTTON_INPUT),
  buttonOutput: new Socket(CONST_SOCKET.BUTTON_OUTPUT),
  buttonOutputSequence: new Socket(CONST_SOCKET.BUTTON_OUTPUT_SEQUENCE),
  
  otnInput: new Socket(CONST_SOCKET.OTN_INPUT),
  otnOutput: new Socket(CONST_SOCKET.OTN_OUTPUT),

  httpApiInput: new Socket(CONST_SOCKET.HTTP_API_INPUT),
  httpApiOutput: new Socket(CONST_SOCKET.HTTP_API_OUTPUT),

  otnSingleInput: new Socket(CONST_SOCKET.OTN_SINGLE_INPUT),
  otnSingleOutput: new Socket(CONST_SOCKET.OTN_SINGLE_OUTPUT),
  otnSingleOutputSequence: new Socket(CONST_SOCKET.OTN_SINGLE_OUTPUT_SEQUENCE),

  rcnInput: new Socket(CONST_SOCKET.RECURRING_NOTIFICATION_INPUT),
  rcnOutput: new Socket(CONST_SOCKET.RECURRING_NOTIFICATION_OUTPUT),

  rcnSingleInput: new Socket(CONST_SOCKET.RCN_SINGLE_INPUT),
  rcnSingleOutput: new Socket(CONST_SOCKET.RCN_SINGLE_OUTPUT),
  rcnSingleOutputSequence: new Socket(CONST_SOCKET.RCN_SINGLE_OUTPUT_SEQUENCE),
  
  userInputFlowInput: new Socket(CONST_SOCKET.USER_INPUT_FLOW_INPUT),
  userInputFlowOutput: new Socket(CONST_SOCKET.USER_INPUT_FLOW_OUTPUT),
  
  userInputFlowSingleInput: new Socket(CONST_SOCKET.USER_INPUT_FLOW_SINGLE_INPUT),
  userInputFlowSingleOutput: new Socket(CONST_SOCKET.USER_INPUT_FLOW_SINGLE_OUTPUT),
  userInputFlowSingleOutputFinalReply: new Socket(CONST_SOCKET.USER_INPUT_FLOW_SINGLE_OUTPUT_FINAL_REPLY),
  
  ecommerceInput: new Socket(CONST_SOCKET.ECOMMERCE_INPUT),
  ecommerceOutput: new Socket(CONST_SOCKET.ECOMMERCE_OUTPUT),
  ecommerceOutputQuickreply: new Socket(CONST_SOCKET.ECOMMERCE_OUTPUT_QUICKREPLY),
  
  genericTemplateInput: new Socket(CONST_SOCKET.GENERIC_TEMPLATE_INPUT),
  genericTemplateOutput: new Socket(CONST_SOCKET.GENERIC_TEMPLATE_OUTPUT),
  genericTemplateOutputButton: new Socket(CONST_SOCKET.GENERIC_TEMPLATE_OUTPUT_BUTTON),
  genericTemplateOutputQuickreply: new Socket(CONST_SOCKET.GENERIC_TEMPLATE_OUTPUT_QUICKREPLY),

  sequenceInput: new Socket(CONST_SOCKET.SEQUENCE_INPUT),
  sequenceOutput: new Socket(CONST_SOCKET.SEQUENCE_OUTPUT),  

  sequenceSingleInput: new Socket(CONST_SOCKET.SEQUENCE_SINGLE_INPUT),
  sequenceSingleOutput: new Socket(CONST_SOCKET.SEQUENCE_SINGLE_OUTPUT),
  
  actionButtonOutput: new Socket(CONST_SOCKET.ACTION_BUTTON_OUTPUT),

  conditionInput: new Socket(CONST_SOCKET.CONDITION_INPUT),
  conditionOutputTrue: new Socket(CONST_SOCKET.CONDITION_OUTPUT_TRUE),
  conditionOutputFalse: new Socket(CONST_SOCKET.CONDITION_OUTPUT_FALSE),

  openaiInput: new Socket(CONST_SOCKET.OPEN_AI_INPUT),
  openaiOutput: new Socket(CONST_SOCKET.OPEN_AI_OUTPUT),
  openaiOutputButton: new Socket(CONST_SOCKET.OPEN_AI_OUTPUT_BUTTON),
  openaiOutputQuickreply: new Socket(CONST_SOCKET.OPEN_AI_OUTPUT_QUICKREPLY),
}